import { mapperModuleMedia } from '../../../core/data-layer/modules/mappers'
/**
 * Payments payment submethod mapper
 * @param {Object} data - content data
 * @return {Object} - normalized data
 */
export default (data) => {
    if (!data) {
        return null
    }
    return {
        id: data?.sys?.id || '',
        name: data?.name || '',
        shortDescription: data?.shortDescription || '',
        description: data?.description || {},
        image: mapperModuleMedia(data.image)
    }
}
